import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './card-input.module.scss';

const style = {
  base: {
    lineHeight: '38px',
  },
  invalid: {
    color: '#cc452b',
  },
};

@classic
@classNames(styles.component)
export default class RequestInformationCardInput extends Component {
  didInsertElement() {
    super.didInsertElement(...arguments);
    let element = this.get('model.cardElement.element');

    element?.update({ style }).mount(this.element.querySelectorAll('.input')[0]);
  }
}
